import { useMemo, useState, type MouseEvent } from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/features/auth/store';
import { getMenuItemsByRoles } from '@/features/menu/menu';
import logoUrl from '@/assets/logo-uremont.png';

export const AdminLayout = () => {
  const profile = useAuthStore((s) => s.profile);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();
  const [openGroups, setOpenGroups] = useState<Record<string, boolean>>({});
  const [cabinetOpen, setCabinetOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const menu = useMemo(() => getMenuItemsByRoles(profile.roles), [profile.roles]);
  const displayName = profile.name || 'Admin';

  const onLogout = async (e: MouseEvent) => {
    e.preventDefault();
    setCabinetOpen(false);
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className={`wrapper${sidebarCollapsed ? ' sidebar-collapse' : ''}`}>
      <header className="main-header">
        <Link to="/stat/online" className="logo">
          <span className="logo-mini">
            <b>U</b>R
          </span>
          <span className="logo-lg">
            <b>U</b>REMONT
          </span>
        </Link>
        <nav className="navbar navbar-static-top">
          <a
            href="#"
            className="sidebar-toggle"
            role="button"
            onClick={(e) => {
              e.preventDefault();
              setSidebarCollapsed((v) => !v);
            }}
          >
            <span className="sr-only">Toggle navigation</span>
          </a>
          <div className="navbar-custom-menu">
            <ul className="nav navbar-nav">
              <li className="dropdown user user-menu">
                <a href="#">
                  <img src={logoUrl} alt="" className="user-image" />
                  <span className="hidden-xs">{displayName}</span>
                </a>
              </li>
              <li className={`dropdown user user-menu${cabinetOpen ? ' open' : ''}`}>
                <a
                  href="#"
                  className="dropdown-toggle"
                  onClick={(e) => {
                    e.preventDefault();
                    setCabinetOpen((v) => !v);
                  }}
                >
                  <span className="hidden-xs">Личный кабинет</span>
                </a>
                {cabinetOpen && (
                  <ul className="dropdown-menu">
                    <li className="user-footer">
                      <div className="pull-right">
                        <a href="#" className="btn btn-default btn-flat" onClick={onLogout}>
                          Выход
                        </a>
                      </div>
                    </li>
                  </ul>
                )}
              </li>
            </ul>
          </div>
        </nav>
      </header>

      <aside className="main-sidebar">
        <section className="sidebar">
          <div className="user-panel">
            <div className="pull-left image">
              <img src={logoUrl} alt="" className="img-circle" />
            </div>
            <div className="pull-left info">
              <p>{displayName}</p>
              <a href="#">
                <i className="fa fa-circle text-success" /> Online
              </a>
              <br />
              <a href="#">{profile.email}</a>
            </div>
          </div>
          <ul className="sidebar-menu tree">
            <li className="header">ОСНОВНОЕ МЕНЮ</li>
            {menu.map((item) => {
              if (item.isMenuBox && item.children) {
                const key = item.className || item.title;
                const open = openGroups[key];
                return (
                  <li key={key} className={`treeview${open ? ' active menu-open' : ''}`}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenGroups((prev) => ({ ...prev, [key]: !prev[key] }));
                      }}
                    >
                      <i className={item.iconClassName} /> <span>{item.title}</span>
                      <span className="pull-right-container">
                        <i className="fa fa-angle-left pull-right" />
                      </span>
                    </a>
                    <ul className="treeview-menu" style={{ display: open ? 'block' : 'none' }}>
                      {item.children.map((child) => (
                        <li key={child.to}>
                          <NavLink to={child.to}>
                            <i className={child.iconClassName || 'fa fa-circle-o'} /> {child.title}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </li>
                );
              }
              return (
                <li key={item.to}>
                  <NavLink to={item.to!}>
                    <i className={item.iconClassName} /> <span>{item.title}</span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </section>
      </aside>

      <div className="content-wrapper">
        <Outlet />
      </div>
    </div>
  );
};
